module.exports = __webpack_public_path__ + "img/SHOPPING_BAG.16f5f2f4.svg";